import { RouteRecordRaw } from "vue-router";
import { PermissionEnum } from "@altertec_gparn/lib";

export default {
  path: "/accounting",
  name: "Accounting",
  meta: { sectionAccess: "ACCOUNTING", redirects: true },
  component: () => import("@/layouts/EmptyLayout.vue"),
  children: [
    {
      path: "supplier-invoices",
      name: "Supplier Invoices Layout",
      redirect: { name: "Supplier Invoices" },
      meta: { permissions: [PermissionEnum.ACCOUNTING_ACCOUNTING] },
      component: () => import("@/layouts/EmptyLayout.vue"),
      children: [
        {
          path: "list",
          name: "Supplier Invoices",
          component: () => import("@/views/auth/accounting/SupplierInvoicesList.vue"),
          meta: { permissions: [PermissionEnum.ACCOUNTING_ACCOUNTING] },
        },
        {
          path: "detail/:id",
          name: "Supplier Invoice Detail",
          component: () => import("@/views/auth/accounting/SupplierInvoiceDetail.vue"),
          meta: { permissions: [PermissionEnum.ACCOUNTING_ACCOUNTING] },
          props: true,
        },
      ],
    },
  ],
} as RouteRecordRaw;
